import React, { useRef, useEffect, useState } from 'react'
import {
  Grid, LinearProgress, IconButton, DialogTitle, DialogContent, Dialog, Box, Typography, Card, CardContent,
} from '@mui/material'
import stylesheet from '../detail-container.stylesheet'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { ClassNameMap, withStyles } from '@mui/styles'
import Draggable from "react-draggable"
import DetailCardComponent from '../detail-card.component'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../redux/store'
import { conditionsList, measurementList, forProfile } from '../comp-config'
interface IProps {
  open: boolean,
  item: any,
  handleDialogClose: any,
  classes: ClassNameMap
}

const PendingItemsDialogComponent: React.FC<IProps> = ({ open, item, handleDialogClose, classes }) => {
  const actionPrgRef = useRef(null) as any
  const [isEvaluationPrg, setIsEvaluationPrg] = useState(false)
  const [isTreatmentPrg, setIsTreatmentPrg] = useState(false)

  let patientDetails = useSelector((state: RootState) => state.patientDetail.patientDetail)
  const [patientDetail, setPatientDetail] = useState({} as any)
  const patientDetailStatus: any = useSelector((state: RootState) => state.patientDetail.status)

  useEffect(() => {
    setPatientDetail({
      ...patientDetails,
      'isActionItems': true,
      actionProgram: item?.program
    })
    const isEvaluationPrg = patientDetails?.program_enrollments?.some((m: any) => m.program_type === 'evaluation' && m.program === item?.program)
    setIsEvaluationPrg(isEvaluationPrg)
    setIsTreatmentPrg(!isEvaluationPrg)
  }, [patientDetails])

  const getMeasurementList = () => {
    let mList = forProfile(measurementList);

    if (isTreatmentPrg && !isEvaluationPrg) {
      return mList.filter((item) => item.parent !== 'ME-THR');
    }
    else if (!isTreatmentPrg && isEvaluationPrg) {
      const meaList = mList.filter((item) => item.parent !== 'ME-PTR');
      const calculators = patientDetail?.measurements?.calculators || [];
      const nonDiagnosisCalculators = calculators.filter((calc: any) => calc.category !== 'diagnosis');

      return (nonDiagnosisCalculators.length <= 0)
        ? meaList.filter((item) => item.parent !== 'ME-CAL')
        : meaList;
    } else {
      return mList;
    }
  };

  const getTreatments = () => {
    return <Grid item xs={12} sm={6} md={4} lg={4} style={{ minWidth: '8rem' }}>
      <Box ml={1} mt={1} className={classes.topTHeader}>
        <Typography variant="h6" color="textSecondary" className={classes.headerTitle}>
          Treatments
        </Typography>
      </Box>
      {isTreatmentPrg &&
        <DetailCardComponent
          patientInfo={patientDetail}
          headerName="Care plans"
          parent="MD-PRMD"
        />
      }
      {isTreatmentPrg &&
        <DetailCardComponent
          patientInfo={patientDetail}
          headerName="Symptom evaluations"
          parent="MD-SXEVAL"
        />
      }
      {isTreatmentPrg &&
        <DetailCardComponent
          patientInfo={patientDetail}
          headerName="Monitors"
          parent="MD-PRMT"
        />
      }
      {isTreatmentPrg &&
        <DetailCardComponent
          patientInfo={patientDetail}
          headerName="Lifestyle plans"
          parent="MD-LS"
        />
      }
    </Grid>
  }

  const getDiagnosisList = () => {
    let cList = forProfile(conditionsList)

    return (isTreatmentPrg)
      ? cList.filter((i: any) => !['DIA-PLAN', 'DIA-TEST', 'DIA-STATUS'].includes(i.parent))
      : cList.filter((item: any) => item.parent !== 'CO-PRB')
  }

  const getConditions = () => {
    return <Grid item xs={12} sm={6} md={4} lg={4}>
      <Box ml={1} className={classes.topTHeader}>
        <Typography variant="h6" color="textSecondary" className={classes.headerTitle}>
          {(!isTreatmentPrg && isEvaluationPrg) ? 'Plans' : 'Conditions and Problems'}
        </Typography>
      </Box>
      {getDiagnosisList()?.map((item: any) =>
        <DetailCardComponent
          patientInfo={patientDetail}
          headerName={item?.headerName}
          parent={item?.parent}
          group={item?.group}
          subGroup={item?.subGroup}
        />
      )}
    </Grid>
  }

  return (
    <Draggable ref={actionPrgRef} defaultPosition={{ x: 0, y: 0 }} handle='.action-item-dialog'>
      <Dialog
        id={'action-program'}
        fullWidth={true}
        maxWidth="md"
        open={open}
        onClose={handleDialogClose}
        aria-labelledby="Actio items"
        hideBackdrop
        disableScrollLock
        onKeyUp={(e) => {
          e.preventDefault();
          if (e.key === 'Enter')
            handleDialogClose()
        }}
        sx={{
          position: "absolute",
          left: '15rem',
          top: '4%'
        }}
      >
        <DialogTitle className={classes.addPatientQuestionHeaderSection} classes={{ root: 'action-item-dialog' }}>
          <Grid container justifyContent="space-between">
            <Grid item>
              <Typography color="textSecondary">
                <small>{`Pending items`}</small>
              </Typography>
              <Typography id="modal-modal-title" variant="h6">
                <strong>{item?.title}</strong>
              </Typography>
            </Grid>
            <Grid item >
              <IconButton size="small" onClick={handleDialogClose}>
                <CloseRoundedIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <Box minHeight={'3rem'}>
          {patientDetailStatus === 'loading' ?
            <Grid item><LinearProgress /></Grid>
            : <DialogContent sx={{ padding: '0px 5px 5px 5px !important', backgroundColor: 'var(--color-background-subtle)' }}>
              <Box className={classes.dialogHeaderBox}>
                <Grid spacing={1} container className={classes.containerPadding}>
                  <Grid item className={classes.fullWidth}>
                    {patientDetails?.error_data && patientDetails?.error_data[item?.program] &&
                      Object.keys(patientDetails?.error_data[item?.program])?.length > 0 &&
                      <Card variant="outlined" className={classes.compactCard}>
                        <CardContent className={[classes.confirmCardBackground, classes.cardsContentPadding].join(' ')}>
                          <Typography variant="subtitle2" className={classes.desc}>
                            Error Details:{' '}
                            <Typography component={'span'} variant="body2" className={classes.desc}>
                              {patientDetails?.error_data[item?.program]?.join(', ')}
                            </Typography>
                          </Typography>
                        </CardContent>
                      </Card>
                    }
                    {patientDetails.needs_update &&
                      <Card variant="outlined" className={classes.compactCard}>
                        <CardContent className={[classes.confirmCardBackground, classes.cardsContentPadding].join(' ')}>
                          <Typography variant="body2" className={classes.desc}>{`Patient profile is not updated.`}</Typography>
                        </CardContent>
                      </Card>
                    }
                    {patientDetails?.pending_task_counts[item?.program] > 0 &&
                      <Card variant="outlined" className={classes.compactCard}>
                        <CardContent className={[classes.confirmCardBackground, classes.cardsContentPadding].join(' ')}>
                          <Typography variant="body2" className={classes.desc}>
                            {`Tasks pending count is ${patientDetails?.pending_task_counts[item?.program]}`}
                          </Typography>
                        </CardContent>
                      </Card>
                    }
                    <Grid container direction="row" justifyContent="flex-start" alignItems="baseline" spacing={1}>
                      <Grid item xs={12} sm={6} md={4} lg={4}>
                        <Box ml={1} mt={1} className={classes.topTHeader}>
                          <Grid container spacing={1}>
                            <Grid item >
                              <Typography variant="h6" color="textSecondary" className={classes.headerTitle}>
                                Measurements
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>

                        {getMeasurementList()?.map((item: any) =>
                          <DetailCardComponent
                            patientInfo={patientDetail}
                            headerName={item?.headerName}
                            parent={item?.parent}
                            group={item?.group}
                            subGroup={item?.subGroup}
                          />
                        )}
                      </Grid>
                      {isEvaluationPrg
                        ? <>
                          {getConditions()}
                          {getTreatments()}
                        </>
                        : <>
                          {getTreatments()}
                          {getConditions()}
                        </>
                      }
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </DialogContent>
          }
        </Box>
      </Dialog>
    </Draggable>
  );
};

export default withStyles(stylesheet)(PendingItemsDialogComponent)
